import React, { useEffect, useState } from 'react';
import { useSessionStore } from '../../hooks/useSessionStore';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import './ContentCalendario.css';  // Importar el archivo CSS
import { MenuLateralAB } from "../../components/menuLateralAA/MenuLateralAB";
import Dropdown from 'react-dropdown';



const ContentCalendario = (props) => {
    const {MenuLateralAux, chageMenuLateralAux} = props;
    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
    const [empresa, setEmpresa] = useState();
    const [fecha, setFecha] = useState(new Date());
    const [horaInicio, setHoraInicio] = useState('09:00');
    const [modaltitle, setModalTitle] = useState('')
    const [modalMsg, setModalMsg] = useState('')
    const [abrirModal, setAbrirModal] = useState(false)
    const [servicios, setServicios] = useState([]);
    const [ListaServicios, setListaServicios] = useState([]);

    const getFecha = () => {
		try {
			let fe = fecha.toISOString().substr(0, 10);
			return fe;
		} catch {
			setFecha(new Date());
			return new Date().toISOString().substr(0, 10);
		}
	};
    
    
    const getDatEmpresa = () => {
        axios({
            method: 'get',
            url: window.ipdirection + 'prestadorServicios/',
            headers: {
                Authorization: 'Bearer ' + Usuario.access,
            },
        }).then((response) => {
            console.log('empresa ', response.data[0]);
            setEmpresa(response.data[0]);
        });
    };

    const get_Servicio_Empresa_Activo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Activo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setListaServicios([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

    const seleccionarServicio = (nombre) => {
        console.log('nombre', nombre)
		// Iteramos sobre cada servicio en la lista de servicios.
		ListaServicios.map((servicio) => {
            console.log('servicio.nombre', servicio.descripcion)
			// Verificamos si el nombre del servicio coincide.
			if (servicio.descripcion === nombre) {
                console.log(servicio)
				// Actualizamos el estado de ServicioSeleccionado copiando los atributos del servicio seleccionado.
				setServicios({...setServicios, ...servicio});
			}
		});
	};

    useEffect(() => {
        getDatEmpresa();
        get_Servicio_Empresa_Activo();
    }, []);

    const bloquearHorario = () => {
        console.log('servicios', servicios)
        axios({
            method: "post",
            url: window.ipdirection + 'bloquear_hora/',
            data: {
                fecha: fecha.toISOString().split('T')[0], // Convertir la fecha al formato YYYY-MM-DD
                horaInicio: horaInicio,
                servicio_empresa_id: servicios.id
            },
            headers: {
                Authorization: 'Bearer ' + Usuario.access,
            }
        }).then(response => {
            console.log(response.data);
            setModalTitle('Exito')
            setModalMsg('Horario bloqueado exitosamente');
            setAbrirModal(true)
        }).catch(error => {
            console.error(error);
            setModalTitle('Ha habido un error')
            setModalMsg('Error al bloquear el horario');
            setAbrirModal(true)
        });
    };

    return (
        <div className='calendario-body'>
            <MenuLateralAB seleccionado={2} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
            <div className='headContentUsuarios'>
                <div className='superiorHeadContentUsuarios'>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                    </div>
                    <div className='centrador titleHeadHistorialFacturas'>
                        <b>Calendario</b>
                    </div>
                </div>
                <div className='separador'></div>
                <div className='menuPresupuestos BotonesSuperiorPresupuestos '>
					<div className='buttonNotificacionesActive'>
						<div className='centrador'>Bloquear Hora</div>
					</div>
                </div>
            </div>
            <div className='calendario-container-body'>
                <div className="calendario-container">
                    <h2 className="calendario-title">Bloquear Horario</h2>
                    <div className="calendario-form">
                        <label className="calendario-label">Seleccionar fecha:</label>
                        <input
							className='inputTextUsuario'
							type='date'
							value={getFecha()}
							min={new Date().toISOString().substr(0, 10)} // Deshabilitar fechas anteriores a hoy
							onChange={(e) => setFecha(new Date(e.target.value))}
						/>
                        {/* <DatePicker 
                            selected={fecha} 
                            onChange={(e) => setFecha(e.target.value)} 
                            minDate={fecha}  // Deshabilitar fechas anteriores a hoy
                            className="calendario-datepicker" 
                        /> */}
                        <label className="calendario-label">Hora de inicio:</label>
                        <input 
                            type="time" 
                            value={horaInicio} 
                            onChange={e => setHoraInicio(e.target.value)} 
                            className="calendario-timepicker" 
                        />
                        <label className="calendario-label">Servicio:</label>
                        {
                            ListaServicios.length === 0 ?
                                <div className="calendario-servicios">No hay servicios disponibles</div>
                            :
                            <Dropdown
                                className='calendario-datepicker'
                                options={ListaServicios.map((servicio) => {
                                    return servicio.descripcion;
                                })}
                                onChange={(e) => seleccionarServicio(e.value)}
                                value={servicios.nombre}
                                placeholder={'-- Selecionar --'}
                            />
                        }
                        <button onClick={bloquearHorario} className="calendario-button">Bloquear Horario</button>
                    </div>
                </div>
            </div>
            <Modal
                centered={true}
                isOpen={abrirModal}
            >
                <ModalHeader>
                    <div className='titulo-modal'>{modaltitle}</div>
                </ModalHeader>
                <ModalBody>
                    <div className='descripcion-servicio descripcion-modal'>
                        {modalMsg}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className='centrador'>
                        <div
                            className='button'
                            onClick={() => setAbrirModal(false)}
                        >
                            <b>Cerrar</b>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
    </div>
    );
};

export default ContentCalendario;